import React from 'react';
import { Button } from "semantic-ui-react";
import DownloadIcon from '@mui/icons-material/Download';

export default function Downloadcsv(props) {
  function commanjson(json_pre) {
    for (var dat of props.maindata) {
      let obj = {};
      for(var arhd of props.arrHeader){
        if(props.filename == 'assign' || props.filename == 'assess' ){
          if(dat.score !== undefined && dat.score !== -1){
            try{
              obj[arhd] = dat[arhd].replace("/"," out of ");
            }catch(err){
              obj[arhd] = dat[arhd];
            }
            
          }
        } else {
          obj[arhd] = dat[arhd];
        }
      }
      if(Object.keys(obj).length > 0){
        json_pre.push(obj);
      }
    }
    return json_pre;
  }
  function miniAssign(json_pre) {
    for (var mini of props.maindata) {
      for(let dat of mini.objects) {
      let obj = {};
      for(var arhd of props.arrHeader){
          if(dat.grade !== undefined && dat.grade !== -1){
            let plused = arhd !== "otitle" ?  " out of 10" : "";
            obj[arhd] = dat[arhd] + plused;
          }
      }
      if(Object.keys(obj).length > 0){
        json_pre.push(obj);
      }

     }
    }
    return json_pre;
  }
  function userdata(json_pre) {
    for (var mini of props.maindata) {
      for (var nuggets of mini.nuggets) {
          json_pre.push({otitle: nuggets.ntitle});
        
        for(let dat of nuggets.objects) {
        let obj = {};
          
            if(dat.userOP !== undefined && dat.userOP.timespent !== undefined ){
              obj.otitle = dat.otitle;
              let newvalue = parseInt(dat.oduration);
              let percent =  (Math.round(dat.userOP.timespent)/newvalue) * 100;
              obj.timespent = percent > 100 ? 100 : Math.round(percent);
            }
        
        if(Object.keys(obj).length > 0){
          json_pre.push(obj);
        }
      }
    }
    }
    return json_pre;
  }
    function downloadcsv() {
    var json_pre = [];
    if(props.filename == 'MiniAssign'){
      json_pre = miniAssign(json_pre);
    } else if(props.filename == 'Users'){
      json_pre =  userdata(json_pre);
    } else {
      json_pre = commanjson(json_pre);
    }
    
        let csvData = ConvertToCSV(json_pre, props.arrHeader,props.newHeaders);
        console.log(csvData)
        let blob = new Blob(["\ufeff" + csvData], {
        type: "text/csv;charset=utf-8;",
        });
    let dwldLink = document.createElement("a");
    let url = URL.createObjectURL(blob);
    let isSafariBrowser =
      navigator.userAgent.indexOf("Safari") != -1 &&
      navigator.userAgent.indexOf("Chrome") == -1;
    if (isSafariBrowser) {
      //if Safari open in new window to save file with random filename.
      dwldLink.setAttribute("target", "_blank");
    }
    dwldLink.setAttribute("href", url);
    dwldLink.setAttribute(
      "download",  props.filename+".csv"
    );
    dwldLink.style.visibility = "hidden";
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
    }
    function strRep(data) {
        if (typeof data == "string") {
          let newData = data.replace(/,/g, " ");
          return newData;
        } else if (typeof data == "undefined") {
          return "-";
        } else if (typeof data == "number") {
          return data.toString();
        } else {
          return data;
        }
      };
      function ConvertToCSV(objArray, headerList,newHeaders) {
       
        let array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
        let str = "";
        let row = "";
    
       
       
        for (let index in newHeaders) {
          row += newHeaders[index] + ",";
        }
        row = row.slice(0, -1);
        str += row + "\r\n";
        for (let i = 0; i < array.length; i++) {
          //let line = (i + 1) + '';
          let line = "";
          for (let index in headerList) {
            let head = headerList[index];
            line +=
              headerList[headerList.length - 1] == headerList[index]
                ? strRep(array[i][head])
                : strRep(array[i][head]) + ",";
          }
          str += line + "\r\n";
        }
        return str;
      };
    return(
        <>
        <Button onClick={()=> downloadcsv()} style={{padding:'0px',float:"right",backgroundColor:"transparent"}} >
             <DownloadIcon color="primary" /></Button>
        </>
    )
}
